import * as yup from 'yup';

import { FormTypeCompletionDetails } from '../actions/forms';
import errorText from './validationTexts';

export const loanCompletionDetails: yup.ObjectSchema<FormTypeCompletionDetails> = yup.object({
    email: yup.string().trim().email(errorText.emailInvalid),
    phone: yup.string().trim().min(8, errorText.phoneLength).max(8, errorText.phoneLength),
});

export default { loanCompletionDetails };
